class SMSSignupForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector('[id$="-sms-signup"]');
    this.formErrorEl = this.querySelector('[id$="-form-error"]');
    this.formSuccessEl = this.querySelector('[id$="-form-success"]');
    this.emailInput = this.querySelector('[id$="-sms-email"]');
    this.consentInput = this.querySelector('[id$="-consent"]');
    this.formButton = this.form.querySelector('button[type="submit"]');

    this.handleSubmit = this.handleSubmit.bind(this);

    this.form.addEventListener('submit', this.handleSubmit);
  }

  async handleSubmit(e) {
    e.preventDefault();
    if (this.consentInput.checked == false) {
      this.formErrorEl.textContent = 'Consent is required';
      return false;
    }
    if (this.emailInput && this.emailInput.value.length < 1) {
      this.formErrorEl.textContent = 'Enter a valid email';
      return false;
    }
    this.formButton.textContent = 'Please wait...';
    if (this.emailInput) {
      const result = await this.postSubmissionMailchimp(this.emailInput.value);
      if (result.result == 'success') {
        this.formSuccessEl.textContent = "Thanks for joining the Pete & Gerry's family of brands!"
        this.form.style.display = 'none';
      } else {
        this.formErrorEl.textContent = result.message;
      }
      console.log(result);
    }
  }

  async postSubmissionMailchimp(email) {
    const baseUrl = 'https://peteandgerrys.us18.list-manage.com/subscribe/post-json';
    const params = new URLSearchParams({
      u: 'ba4c98ad3b64ce00b9b01848a',
      id: '3a8bb2fa7d',
      EMAIL: email,
      b_ba4c98ad3b64ce00b9b01848a_6ae970c4e1: '', // honeypot field, must be blank
      c: 'mailchimpCallback',                      // JSONP callback name
    });

    return new Promise((resolve, reject) => {
      // JSONP: inject a script tag instead of fetch
      const script = document.createElement('script');

      window.mailchimpCallback = (data) => {
        delete window.mailchimpCallback;
        script.remove();

        if (data.result === 'success') {
          resolve(data);
        } else {
          reject(new Error(data.msg)); // e.g. "already subscribed", "invalid email"
        }
      };

      script.src = `${baseUrl}?${params.toString()}`;
      script.onerror = () => reject(new Error('Mailchimp request failed'));
      document.body.appendChild(script);
    });
  }
}
customElements.define('sms-signup-form', SMSSignupForm);
